
export default function Hero() {
  return (
    <div className="relative min-h-screen flex items-center bg-gradient-to-br from-gray-50 via-blue-50/30 to-white pt-20">
      <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent"></div>
      
      <div className="relative w-full px-8 lg:px-16 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center max-w-7xl mx-auto">
          <div className="space-y-8">
            <h1 className="text-6xl lg:text-7xl font-bold text-gray-900 leading-tight">
              Modern iOS Applications for Enhanced Security
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed max-w-xl">
              We are a team of experts developing cutting-edge applications for the iOS platform. Our products are designed to enhance user experience and improve the security of mobile devices.
            </p>
          </div>
          
          <div className="flex justify-center lg:justify-end">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-400/20 to-purple-400/20 rounded-3xl blur-3xl"></div>
              <img
                src="https://public.readdy.ai/ai/img_res/48afb55eb7a2d9dabf78e3aab102e7ef.jpg"
                alt="iOS Application Mockup"
                className="relative w-full max-w-md h-auto object-contain drop-shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
